import { LocationsCarousel } from "./LocationsCarousel";
import Pindrop from "../../../../icons/Pindrop";
import HammerIcon from "../../../../icons/HammerIcon";
export default function AvailableLocations(props: any) {
  return (
    <>
      <div className="flex">
        <div
          className="relative w-full mt-2  pt-[135px] pb-[44px] px-customPaddingMobile  bg-[url('/leftmapmobile.png'),url('/rightmapmobile.png')] bg-[position:left_center,right_center] bg-[size:82%_100%,69%_100%] bg-no-repeat  lg:mt-20 lg:h-[638px] lg:pt-[166px] lg:pb-[148px] lg:px-customPadding lg:bg-[url('/leftmap.png'),url('/rightmap.png')] 
           lg:bg-[position:-21px_center,calc(100%+31px)_center] 
           lg:bg-[size:46.25%_100%,58.12%_100%] 
           lg:bg-no-repeat 2xl:w-full 2xl:px-auto"
        >
          {/* Hammer Icon */}
          <div className="flex">
            <div className="absolute left-[85px] -top-[4px] z-1  lg:left-[329px] lg:top-[61px]">
              <HammerIcon className="h-[71px] w-[71px] lg:h-[121.7px] lg:w-[121.7px]" />
            </div>
            <div className="absolute left-[26px] top-[75px] z-1 lg:left-[241px] lg:top-[170px]">
              <HammerIcon className="h-[71px] w-[71px] lg:h-[121.7px] lg:w-[121.7px]" />
            </div>
            <div className="absolute right-[86px] -top-[10px] z-1 lg:right-[390px] lg:top-[40px]">
              <HammerIcon className="h-[71px] w-[71px] lg:h-[121.7px] lg:w-[121.7px]" />
            </div>
            <div className="absolute right-[16px] top-[75px] z-1 lg:right-[170px] lg:top-[120px]">
              <HammerIcon className="h-[71px] w-[71px] lg:h-[121.7px] lg:w-[121.7px]" />
            </div>
          </div>

          {/*Text Heading */}
          <div className="relative z-2 max-w-[297px]  mx-auto md:max-w-[330px] lg:max-w-[587px]">
            <div className="flex w-full mb-1 items-center  lg:justify-around lg:px-6 lg:mb-1.5">
              <p className="font-spaceGrotesk font-normal leading-[30px] justify-start text-mobile-h3 md:text-mobile-h2 lg:leading-[61px] lg:text-web-h2">
                AVAILABLE IN{" "}
              </p>

              <div className="mx-auto lg:hidden">
                <Pindrop width="70px" height="40px"></Pindrop>
              </div>
              <div className="hidden lg:flex">
                <Pindrop width="102px" height="59px"></Pindrop>
              </div>

              <p className="font-spaceGrotesk font-normal leading-[30px] text-mobile-h3 md:text-mobile-h2 lg:leading-[61px] lg:text-web-h2 ">
                30+
              </p>
            </div>
            <p className="font-spaceGrotesk font-normal   leading-[30px] text-mobile-h3 text-center md:text-mobile-h2 lg:leading-[61px] lg:text-web-h2">
              LOCATIONS IN INDIA
            </p>
          </div>

          {/* Carousel */}
          <div className="mt-[78px] lg:mt-[83px]  w-full max-w-[1147px] mx-auto">
            <LocationsCarousel />
          </div>
        </div>
      </div>
    </>
  );
}
